module.exports = __webpack_public_path__ + "static/media/zoo.342b5421.webp";